import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DownloadButton } from "../../components/Core/Button/Button";
import Dropdown from "../../components/Core/Dropdown/Dropdown";
import Flex from "../../components/Layout/Flex";
import Breadcrumbs from "../../components/Shared/Breadcrumbs/Breadcrumbs";
import { CustomerContractsReportBreadcrumbs } from "../../configs/breadcrumbNavigation";
import { ViewModels } from "../../configs/constants/ViewModels";
import {
	buildContractKeyValues,
	buildPoolKeyValues,
	statusTypes,
} from "../../configs/Reports.config";
import { KeyValue } from "../../models/KeyValue";
import { CONTRACT_SORTING_COLUMN } from "../../models/Sorting";
import { useContracts } from "../../networking/contract.hooks";
import { useOrganisation } from "../../networking/organisation.hooks";
import { apiStore } from "../../stores/api.store";
import { reportStore } from "../../networking/report.api";

const CustomerContactsReportPage: React.FC = () => {
	const { t } = useTranslation();

	const [contract, setContract] = useState<KeyValue>();
	const [pool, setPool] = useState<KeyValue>();
	const [status, setStatus] = useState<KeyValue>();
	const [loading, setLoading] = useState<boolean>();

	const { data: organisation } = useOrganisation();
	const { contracts = [] } = useContracts({
		view: ViewModels.SELECT_OPTION,
		active: true,
		sort: CONTRACT_SORTING_COLUMN.NAME,
	});

	const pools = buildPoolKeyValues(organisation?.pools || [], t("ALL"));
	const contractOptions = buildContractKeyValues(contracts, t("ALL"));

	const handlePoolChange = (e: KeyValue) => {
		setPool(e);
	};

	const handleStatusChange = (e: KeyValue) => {
		setStatus(e);
	};

	const handleContractChange = (e: KeyValue) => {
		setContract(e);
	};

	const onSubmit = async () => {
		let selectedPool!: string;
		let selectedStatus!: string;
		let selectedContract!: string;

		if (pool?.key && pool?.key !== "") selectedPool = pool?.key as string;
		if (status?.key && status.key !== "") selectedStatus = status.key as string;
		if (contract?.key && contract.key !== "") selectedContract = contract.key as string;

		setLoading(true);
		const url = await reportStore.getCustomerContactsReport(
			selectedPool,
			selectedContract,
			selectedStatus
		);
		setLoading(false);

		if (url) {
			// https://stackoverflow.com/a/59352848
			const downloadLink = document.createElement("a");
			downloadLink.href = apiStore.apiRoot + url;
			downloadLink.download = apiStore.apiRoot + url;
			downloadLink.click();
		}
	};

	return (
		<div className="p-4 px-6">
			<Breadcrumbs items={CustomerContractsReportBreadcrumbs} />
			<Flex flexWrap="wrap" margin="1.5rem 0" maxWidth="800px" alignItems="flex-end">
				<Dropdown<KeyValue, KeyValue>
					value={contract}
					getValue={(o) => o}
					onChange={handleContractChange}
					getOptionLabel={(option) => option.value}
					options={contractOptions}
					placeholder={"reports.filters.contract.placeHolder"}
					label={"reports.filters.contract.label"}
					width="300px"
				/>
				{pools.length > 0 && (
					<Dropdown<KeyValue, KeyValue>
						value={pool}
						getValue={(o) => o}
						onChange={handlePoolChange}
						getOptionLabel={(option) => option.value}
						options={pools}
						placeholder={"reports.filters.pool.placeHolder"}
						label={"reports.filters.pool.label"}
						width="300px"
					/>
				)}
				<Dropdown<KeyValue, KeyValue>
					value={status}
					getValue={(o) => o}
					onChange={handleStatusChange}
					getOptionLabel={(option) => option.value}
					options={statusTypes()}
					placeholder={"reports.filters.status.placeHolder"}
					label={"reports.filters.status.label"}
					width="300px"
				/>
			</Flex>
			<DownloadButton width="250px" height="38px" onClick={onSubmit} loading={loading}>
				{t("reports.export")}
			</DownloadButton>
		</div>
	);
};

export default CustomerContactsReportPage;
